<div class="row" *ngIf="(contact | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">First Name</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="contact.firstName" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Last Name</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="contact.lastName" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Title Description</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="contact.title" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Type</label>
            </div>
            <div class="col-sm-9">
                <select name="contactTitleID" [(ngModel)]="contact.contactTitleID" class="form-select" required [disabled]="contactTitleID>0">
                    <option *ngFor="let contactTitle of contactTitleList" value="{{contactTitle.contactTitleID}}">{{contactTitle.description}}</option>
                </select>
            </div>
        </div>
        <div class="row" *ngIf="contactTitleID!=3">
            <div class="col-sm-3">
                <label class="font-weight-bold">Phone Country</label>
            </div>
            <div class="col-sm-9">
                <select name="phoneCountryID" [(ngModel)]="contact.phoneCountryID" class="form-select" (change)="phoneCountryChange($event, 'phone')">
                    <option *ngFor="let country of countryList" value="{{country.countryId}}">{{country.name}}</option>
                </select>
            </div>
        </div>
        <div class="row" *ngIf="contactTitleID!=3">
            <div class="col-sm-3">
                <label class="font-weight-bold">Phone</label>
            </div>
            <div class="col-sm-5">
                <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="contact.phone" [disabled]="contact.phoneCountryID == null"></kendo-maskedtextbox>
            </div>
            <div class="col-sm-2">
                <label class="font-weight-bold">Ext</label>
            </div>
            <div class="col-sm-2">
                <input type="text" class="form-control" [(ngModel)]="contact.phoneExt" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Cell Country</label>
            </div>
            <div class="col-sm-9">
                <select name="cellCountryID" [(ngModel)]="contact.cellCountryID" class="form-select" (change)="phoneCountryChange($event, 'cell')">
                    <option *ngFor="let country of countryList" value="{{country.countryId}}">{{country.name}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Cell</label>
            </div>
            <div class="col-sm-9">
                <kendo-maskedtextbox [mask]="cellMask" class="form-control" type="text" [(ngModel)]="contact.cell" [disabled]="contact.cellCountryID == null"></kendo-maskedtextbox>
            </div>
        </div>
        <div class="row" *ngIf="contactTitleID!=3">
            <div class="col-sm-3">
                <label class="font-weight-bold">Fax</label>
            </div>
            <div class="col-sm-9">
                <kendo-maskedtextbox [mask]="faxMask" class="form-control" type="text" [(ngModel)]="contact.fax"></kendo-maskedtextbox>
            </div>
        </div>
        <div class="row" *ngIf="contactTitleID!=3">
            <div class="col-sm-3">
                <label class="font-weight-bold">Email</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="contact.email" />
            </div>
        </div>
        <div class="row" *ngIf="contactTitleID!=3">
            <div class="col-sm-3">
                <label class="font-weight-bold">Default</label>
            </div>
            <div class="col-sm-9">
                <input type="checkbox" [(ngModel)]="contact.defaultContactInd" style="transform:scale(1.5);" />
            </div>
        </div>
        <div class="row" *ngIf="contactType.toLowerCase()=='customer'">
            <div class="col-sm-3">
                <label class="font-weight-bold">Customer Portal Access?</label>
            </div>
            <div class="col-sm-9">
                <input type="checkbox" [(ngModel)]="contact.isAllowedVisibiltyToCustomerPortal" style="transform:scale(1.5);" />
            </div>
        </div>
        <div class="row" *ngIf="contactType.toLowerCase()=='carrier'">
            <div class="col-sm-3">
                <label class="font-weight-bold">Email Carrier Portal Link?</label>
            </div>
            <div class="col-sm-9">
                <input type="checkbox" [(ngModel)]="contact.isEmailCarrierPortalLink" style="transform:scale(1.5);" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-end">
            <button class="btn btn-primary m-2" (click)="saveContact()">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancelContact()">Cancel</button>
        </div>
    </div>
</div>
